module.exports = __webpack_public_path__ + "img/bus_orange_1.4ed65238.svg";